// Module
var code = "<div class=\"map\"></div>\r\n";
// Exports
module.exports = code;